import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enNav from './locales/en/nav.json';
import jaNav from './locales/ja/nav.json';
i18n
    .use(initReactI18next)
    .init({
    resources: {
        en: { nav: enNav },
        ja: { nav: jaNav },
    },
    lng: localStorage.getItem('netx-lang') || 'en',
    fallbackLng: 'en',
    ns: ['nav'],
    defaultNS: 'nav',
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
